import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按类型快速找到你想看的内容，总有一个频道适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {item.desc}
              </p>
              <span className="inline-block text-xs font-medium text-foreground-400 bg-background-100 px-2.5 py-1 rounded-full">
                {item.count.toLocaleString()} 部
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}